// extracted by mini-css-extract-plugin
module.exports = {"root":"storyList_root__WfAqH"};